import React from 'react';
import { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { jwtDecode } from "jwt-decode";
import Forbidden from '../../page/Shared/Forbidden';

const PrivateRoute = (props) => {

    const { userInfo } = useContext(UserContext);

    if (props?.roles?.length > 0 && userInfo?.accesstoken) {
        let tDecodeJwt = jwtDecode(userInfo?.accesstoken);
        if (tDecodeJwt?.roles?.length > 0 && tDecodeJwt?.roles?.some(r => props?.roles?.includes(r))) {
            return props?.children;
        }
    }
    return <Forbidden />
}

export default PrivateRoute;